import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { Observable } from 'rxjs';
import { State } from 'src/app/shared/models/state';
import { combine } from 'src/app/shared/utilities/route';
import { CountryState, ZipCode } from 'src/app/shared/models/lookup-country-states.model';

const US_COUNTRY_ID = 1;

@Injectable({
    providedIn: 'root'
})
export class StatesService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) private readonly settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova/states');
    }

    getStates(): Observable<State[]> {
        return this.http.get<State[]>(this.coreApiPath);
    }

    getCountryStates(): Observable<CountryState[]> {
        return this.http.get<CountryState[]>(this.coreApiPath);
    }

    getUSstates(): Observable<State[]> {
        return this.http.get<State[]>(`${this.coreApiPath}?countryId=${US_COUNTRY_ID}`);
    }

    getStatesForCountries(countryIds: number[]): Observable<CountryState[]> {
        return this.http.post<CountryState[]>(`${this.coreApiPath}/by-countries`, countryIds);
    }

    getZipCodes(zipCode: string): Observable<ZipCode[]> {
        return this.http.get<ZipCode[]>(`${this.coreApiPath}/zipCodes?zipCode=${zipCode}`);
    }
}
